import React from 'react'
import { useGlobalContext } from './context'

const Search = () => {
  const{query,setquery,isError}=useGlobalContext();
  
  return (
    <section className='search-section'>
      <h1>🎥 Search Your Favourite Movie </h1>
      <form action='#' onSubmit={(e)=>{e.preventDefault()}}>
        <div>
          <input type="text" placeholder='enter movie name'
          value={query}
          onChange={(e)=>{setquery(e.target.value)}}
          />
        </div>
      </form>
      <div className='card-error'>
        <p>{isError.show && isError.msg}</p>
      </div>

    </section>
  )
}

export default Search
